import { IGetReportsAction } from './reports.interface';

export type GetReportsParams = {
	hospital_id?: string;
	hospital_name?: string;
	createdMonthVN?: string;
	year?: string;
	sortBy?: any;
	pageSize?: any;
	page?: any;
};

export enum GetReportsTypes {
	GET_REPORTS = 'GET_REPORTS',
}

export type GetReportsAction = IGetReportsAction;
